module.exports = __webpack_public_path__ + "static/img/banner_5.30c545ea.png";